import { useEffect } from 'react';

import { getConfigLists } from '../helpers';

export const useClearPackageInit = (clearState) => {
  const { clearDefaultClientId, clearDefaultScope, clearEnvironment, clearRedirectUri } = getConfigLists();
  useEffect(() => {
    const script = document.createElement('script')

    const [uuid, clientId, scope] = clearState.split('*');

    script.addEventListener('load', () => {
      const initScript = document.createElement('script')
      initScript.id = 'buttonInit'
      initScript.innerText = `
      ClearMe.init(
        "clear-button",
        {
          clientId: "${clientId ? atob(clientId) : clearDefaultClientId}",
          redirectURI: "${clearRedirectUri}",
          environment: ${clearEnvironment},
          state: "${clearState}",
          useCase: "${clientId ? atob(clientId) : clearDefaultClientId}",
          scope: "${scope ? atob(scope) : clearDefaultScope}",
          size: "small"
        }
      )`

      document.body.appendChild(initScript);
    })

    script.id = 'clearMeSDK'
    script.src = 'https://sdk.clearme.com/clearme_6.0.1.js'
    script.async = true

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    }
  }, []);
};
